import useAppConfig from 'canvas_states/config/useAppConfig';
import useShoppingCart from 'canvas_states/shoppingCart/useShoppingCart';

const useShouldHideSelector = (hideCurrencySelector = false) => {
  const {
    states: { config },
    selectors: { getLanguages, getCurrencies },
  } = useAppConfig();
  const cartItemsCount = useShoppingCart().states.shoppingCart.items.length;
  const languages = getLanguages();
  const currencies = getCurrencies();

  const shouldHideLanguageSelector = !config.usesLanguageSelector || languages.length < 2;

  const shouldHideCurrencySelector =
    !config.usesCurrencySelector || hideCurrencySelector || cartItemsCount > 0 || currencies.length < 2;

  return {
    states: {
      shouldHideCurrencySelector,
      shouldHideLanguageSelector,
    },
  };
};
export default useShouldHideSelector;
